// src/core/hooks/usePermissions.ts
import { useAppSelector } from '@app/store/hooks';
import { Permission } from '@core/constants/permissions';
import { useMemo } from 'react';
import { expandPermissions } from '@core/utils/permissionDependencies';

export const usePermissions = () => {
  const { permissions: assignedPermissions, roles, roleTitles } = useAppSelector((state) => state.auth);
  const permissions = useMemo(
    () => expandPermissions(assignedPermissions),
    [assignedPermissions],
  );

  const hasPermission = (permission: Permission): boolean => {
    return permissions.includes(permission);
  };

  const hasAnyPermission = (permissionList: Permission[]): boolean => {
    return permissionList.some((permission) => permissions.includes(permission));
  };

  const hasAllPermissions = (permissionList: Permission[]): boolean => {
    return permissionList.every((permission) => permissions.includes(permission));
  };

  const hasRole = (role: string): boolean => {
    return roles.includes(role);
  };

  return {
    permissions,
    roles,
    roleTitles,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasRole,
  };
};

